import { render, staticRenderFns } from "./TournamentSerials.vue?vue&type=template&id=80a42c94"
import script from "./TournamentSerials.vue?vue&type=script&lang=js"
export * from "./TournamentSerials.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports